import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const API_BASE = process.env.REACT_APP_URL;

export default function GooglePasswordCheck() {
  const navigate = useNavigate();

  const googleEmail = localStorage.getItem("googleEmail");
  const googleName = localStorage.getItem("googleName");
  const googlePicture = localStorage.getItem("googlePicture");

  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  if (!googleEmail) {
    return (
      <h3 style={{ textAlign: "center", marginTop: "50px" }}>
        Invalid Google session
      </h3>
    );
  }

  useEffect(() => {
    const checkUser = async () => {
      try {
        const res = await fetch(`${API_BASE}/users/check/${googleEmail}`);
        const data = await res.json();

        if (!data.exists) {
          navigate("/signup-google");
        }
      } catch (err) {
        console.error(err);
      }
    };

    checkUser();
  }, [googleEmail, navigate]);

  const handleLogin = async () => {
    if (!password) return setError("Enter your password");

    try {
      const res = await fetch(`${API_BASE}/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email: googleEmail,
          username: googleName || "",
          password,
        }),
      });

      const data = await res.json();

      if (!res.ok) {
        setError(data.error);
        return;
      }

      localStorage.setItem("userEmail", googleEmail);
      localStorage.setItem("userName", googleName || "");
      localStorage.setItem("userPicture", googlePicture || "");

      navigate("/DetectorApp");
    } catch (err) {
      console.error(err);
      setError("Server error");
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <h2>Welcome back!</h2>
        <p>Login using your Google-linked account password</p>

        {googlePicture && (
          <img src={googlePicture} alt="profile" style={styles.pic} />
        )}

        <input
          type="email"
          value={googleEmail}
          readOnly
          style={styles.input}
        />

        {error && <p style={styles.error}>{error}</p>}

        <input
          type="password"
          placeholder="Enter password"
          style={styles.input}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        <button style={styles.button} onClick={handleLogin}>
          Login
        </button>

        <p
          style={styles.forgot}
          onClick={() => navigate("/forgot-password")}
        >
          Forgot password?
        </p>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    background: "#eef1ff",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  card: {
    width: "350px",
    padding: "25px",
    background: "#fff",
    borderRadius: "12px",
    textAlign: "center",
    boxShadow: "0 4px 20px rgba(0,0,0,0.12)",
  },
  input: {
    width: "100%",
    padding: "12px",
    borderRadius: "8px",
    border: "1px solid #ccc",
    marginTop: "12px",
  },
  button: {
    width: "100%",
    padding: "12px",
    background: "#636CCB",
    color: "white",
    border: "none",
    borderRadius: "8px",
    marginTop: "20px",
    cursor: "pointer",
    fontSize: "16px",
  },
  pic: {
    width: "60px",
    height: "60px",
    borderRadius: "50%",
    marginBottom: "10px",
  },
  forgot: {
    marginTop: "10px",
    color: "#636CCB",
    cursor: "pointer",
    textDecoration: "underline",
  },
  error: { color: "red", marginTop: "10px" },
};
